module.exports = __webpack_public_path__ + "img/1f35c.3135c94.svg";